<template>
  <div>
    <div class="row">
		<div class="col s12 m8 l10 xl10">
			<div class="row">
				<div class="input-field col s12">
					<i class="material-icons prefix">search</i>
					<input id="search" type="text" class="validate" v-model="filterTerm" v-on:keyup.enter="verifyUsuarios();" placeholder="Nome, e-mail, CPF">
					<label for="search">Pesquisar</label>
				</div>		
			</div>
			<div class="row">
				<div class="input-field col s12 m6 l6 xl6">
					<select name="perfil" v-model="perfil" class="browser-default select_sec">
						<option disabled value="-1">Escolha o perfil</option>
						<option selected value="0">Todos os perfis</option>
						<template v-for="(perfil, index) in this.perfisUsu">
							<option v-if="root == true || index > 1" v-bind:value="index">{{ perfil[0] }}</option>
						</template>
					</select>
				</div>
				<div class="input-field col s12 m6 l6 xl6">
					<button :disabled="perfil < 0 || (filterTerm.length < 3 && filterTerm.length > 0)" class="btn teal" @click="verifyUsuarios();"><i class="material-icons left">search</i>Pesquisar</button>
				</div>	
			</div>
		</div>
	</div>

    <div class="row">
      <div class="col s12 m12 l12 xl12">

        <!-- <pre>{{ [sortProperty, sortDirection, sortPropertyId] | json }}</pre> -->

        <table>
          <thead>
            <tr>
              <th class="hide-on-med-and-down">
                #
                <a class="left" href="#" @click="toggleOrder($event, 'id')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
                </a>
              </th>
              <th>
                CPF
                <a class="left" href="#" @click="toggleOrder($event, 'cpf')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyCPF }" >sort</i>
                </a>
              </th>
              <th>
                Nome
                <a class="left" href="#" @click="toggleOrder($event, 'nome')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyNome }" >sort</i>
                </a>
              </th>
              <th class="hide-on-med-and-down">
                e-mail
                <a class="left" href="#" @click="toggleOrder($event, 'email')">
                  <i class="material-icons" v-bind:class="{ 'red-text': sortPropertyEmail }" >sort</i>
                </a>
              </th>
              <th class="hide-on-med-and-down">
                Perfil
              </th>
              <th>
                Edit.
              </th>
			  <th v-if='root == true'>
                Assumir papel
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="usuario in filteredUsers">
              <td class="hide-on-med-and-down">{{ usuario.id }}</td>
              <td>{{ usuario.cpf }}</td>
              <td>{{ usuario.name }}</td>
              <td class="hide-on-med-and-down">{{ usuario.email }}</td>
              <td class="hide-on-med-and-down">
                <div v-for="(perfil, index) in perfisUsu">
                  <span v-if="usuario.perfil & index" class="new badge grey lighten-1" data-badge-caption="">
					{{ perfil[0] }}
				  </span>
				</div>
              </td>
              <td>
                <a data-tooltip="Editar usuário" :href="'/usuario/' + usuario.id + '/edit'" class="waves-effect waves-light btn-small tooltipped">
                  <i class="material-icons">edit</i>
                </a>
              </td>
			  <td v-if='root == true'>
				<button data-tooltip="Assumir papel" class="waves-effect waves-light btn-small tooltipped" @click='assumirPapel(usuario.id)'>
                  <i class="material-icons">person</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueUsuarios",
      props: [
        'usuarios',
		'perfis',
		'root'
      ],
      data () {
        return {
		  todosUsuarios: JSON.parse(this.usuarios),
          listaUsuarios: JSON.parse(this.usuarios),
		  perfisUsu: JSON.parse(this.perfis),
          sortProperty: 'id',
          sortDirection: 'asc',
          filterTerm: '',
          sortPropertyId: true,
          sortPropertyCPF: false,
          sortPropertyNome: false,
          sortPropertyEmail: false,
		  perfil: 0,
		    
        }
      },
      computed: {
        listUsuariosOp: function () {
          this.listaUsuarios = _.orderBy(this.listaUsuarios, this.sortProperty, this.sortDirection)
        },
        filteredUsers: function () {
          return _.orderBy(this.listaUsuarios, this.sortProperty, this.sortDirection)
        },
      },
      methods: {
        toggleOrder (ev, field) {
          ev.preventDefault()
          if (this.sortProperty == field){
            if (this.sortDirection == 'asc')
              this.sortDirection = 'desc'
            else
              this.sortDirection = 'asc'
          } else {
            this.iconsColor(this.sortProperty, false)
            this.iconsColor(field, true)
            this.sortProperty = field
            this.sortDirection = 'asc'
          }
        },
		verifyUsuarios() {
			var self = this
			this.listaUsuarios = self.todosUsuarios.filter(function (user) {
            var searchRegex = new RegExp(self.filterTerm, 'i')
            return (
              (searchRegex.test(user.id) ||
              searchRegex.test(user.name) ||
              searchRegex.test(user.email) ||
              searchRegex.test(user.cpf))
			  && (self.perfil <= 0 || (self.perfil & user.perfil))
            )
          })
		},
        iconsColor(field, value){
          switch (field) {
            case 'id':
              this.sortPropertyId = value
              break;
            case 'cpf':
              this.sortPropertyCPF = value
              break;
            case 'name':
              this.sortPropertyNome = value
              break;
            case 'email':
              this.sortPropertyEmail = value
              break;
            default:
          }
        },
		assumirPapel: function (id) {
			this.$http.get('/api/usuario/assumir/' + id).then((req) => {window.location.replace('/dados/false');})
		}
      },
    }
</script>
